import { atom } from 'jotai';

export const atomWithLocalStorage = <
  T extends
    | string
    | number
    | boolean
    | unknown[]
    | Record<string, unknown>
    | null
    | undefined,
>(
  key: string,
  initialValue: T
) => {
  const getInitialValue = () => {
    const item = localStorage.getItem(key);
    if (item !== null) {
      return JSON.parse(item) as T;
    }
    if (typeof initialValue === 'function') {
      return (initialValue as () => T)();
    }
    return initialValue;
  };
  const baseAtom = atom<T>(getInitialValue());
  return atom(
    (get) => get(baseAtom),
    (get, set, update: T | ((arg: T) => T)) => {
      const nextValue =
        typeof update === 'function' ? update(get(baseAtom)) : update;
      set(baseAtom, nextValue);
      localStorage.setItem(key, JSON.stringify(nextValue));
    }
  );
};
